import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import "core-js/modules/es.object.to-string.js";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@govhhs/govhhs-design-system-react';
import { injectIntl } from 'react-intl';
import translations from './SessionTimeoutDialogComponentMessages';
import SessionTimeoutCountDown from './SessionTimeoutCountDown';
import { ID } from './constants';
var SessionTimeoutDialogComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(SessionTimeoutDialogComponent, _PureComponent);
  var _super = _createSuper(SessionTimeoutDialogComponent);
  function SessionTimeoutDialogComponent() {
    var _context;
    var _this;
    _classCallCheck(this, SessionTimeoutDialogComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    // Register an event listener for browser back button events.
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      window.addEventListener('popstate', _this.handlePopState);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('popstate', _this.handlePopState);
    });
    _defineProperty(_assertThisInitialized(_this), "handlePopState", function () {
      var onStaySignedIn = _this.props.onStaySignedIn;
      onStaySignedIn();
    });
    _defineProperty(_assertThisInitialized(_this), "handleSignOutButton", function () {
      var onSignOutAndRedirectToLogin = _this.props.onSignOutAndRedirectToLogin;
      onSignOutAndRedirectToLogin(false);
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        onStaySignedIn = _this$props.onStaySignedIn,
        inactivityDialogCount = _this$props.inactivityDialogCount,
        onSignOutAndRedirectToLogin = _this$props.onSignOutAndRedirectToLogin;
      var titleText = intl.formatMessage(translations.title);
      var logOutBtnText = intl.formatMessage(translations.signOutButton);
      var stayLoggedInBtnText = intl.formatMessage(translations.stayButton);
      return /*#__PURE__*/React.createElement(Dialog, {
        ariaLabel: "".concat(intl.formatMessage(translations.titleAriaLabel, {
          titleText: titleText,
          logOutBtnText: logOutBtnText,
          stayLoggedInBtnText: stayLoggedInBtnText
        })),
        blocking: true,
        "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_ID,
        onActionButtonClick: onStaySignedIn,
        open: true,
        primaryButton: /*#__PURE__*/React.createElement(Button, {
          category: "primary",
          "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_STAY_LOGGED_IN_BUTTON_ID
        }, stayLoggedInBtnText),
        secondaryButton: /*#__PURE__*/React.createElement(Button, {
          category: "link",
          "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_STAY_SIGN_OUT_BUTTON_ID,
          onClick: _this.handleSignOutButton
        }, logOutBtnText),
        title: intl.formatMessage(translations.title)
      }, /*#__PURE__*/React.createElement(SessionTimeoutCountDown, {
        inactivityDialogCount: inactivityDialogCount,
        onSignOutAndRedirectToLogin: onSignOutAndRedirectToLogin
      }));
    });
    return _this;
  }
  return _createClass(SessionTimeoutDialogComponent);
}(PureComponent);
SessionTimeoutDialogComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  inactivityDialogCount: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  onSignOutAndRedirectToLogin: PropTypes.func.isRequired,
  onStaySignedIn: PropTypes.func.isRequired
} : {};
export default injectIntl(SessionTimeoutDialogComponent);